function buildDataId(...segments: Array<string | number | undefined | null | false>) {
  return segments
    .filter((segment): segment is string | number => segment !== undefined && segment !== null && segment !== false)
    .map(segment => String(segment))
    .join("-")
}

function slugifyDataId(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export { buildDataId, slugifyDataId }
